import { render, staticRenderFns } from "./DetailStock.vue?vue&type=template&id=fb0e1802&scoped=true&"
import script from "./DetailStock.vue?vue&type=script&lang=js&"
export * from "./DetailStock.vue?vue&type=script&lang=js&"
import style0 from "./DetailStock.vue?vue&type=style&index=0&id=fb0e1802&scoped=true&lang=css&"
import style1 from "./DetailStock.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0e1802",
  null
  
)

export default component.exports